// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__ikV92","small":"button_small__O5o1o","medium":"button_medium___tmyX","big":"button_big__0bS_i","primary":"button_primary__m3roW"};